import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ProjectNamePipe } from '../shared/pipes/project-name.pipe';

import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from '../shared/services/project.service';

@Component({
  selector: 'app-project-pagehearder',
  imports: [ProjectNamePipe, RouterLink],
  templateUrl: './project-pagehearder.component.html',
  styleUrl: './project-pagehearder.component.scss'
})

export class ProjectPagehearderComponent {

  constructor(
    public projectService: ProjectService,
    private route: ActivatedRoute,
    public loginService: LoginService

  ) { }

  public get project() {
    const projectId = this.route.snapshot.pathFromRoot
      .map(route => route.paramMap.get('projectid')).find(id => id !== null);
    if (!projectId) return undefined;
    // Keep the displayed breadcrumb tied to the active project during navigation.
    return this.projectService.projects.find(project => project._id === projectId)
      ?? (this.projectService.selectedProject?._id === projectId ? this.projectService.selectedProject : undefined);
  }

  // Getter für das Template
  public get isArchivePage(): boolean {
    return this.route.snapshot.pathFromRoot.some(route => route.routeConfig?.path === 'archive');
  }

  public get isTrashPage(): boolean {
    return this.route.snapshot.pathFromRoot.some(route => route.routeConfig?.path === 'trash');
  }

  public get showMandant(): boolean {
    const project = this.project;
    return !!project && project._id !== '-' && project.orgShort !== '' && (this.loginService.loggedInUser?.orgShorts.length ?? 0) > 1;
  }

}
